// extracted by mini-css-extract-plugin
module.exports = {"container":"xvpfoSAxoGqz8PCrp_AV4"};